module.exports = __webpack_public_path__ + "img/4c.76db8c51.png";